import AppRoutes from "AppRoutes";
import Header from "components/shared/Header";
import Footer from "components/shared/Footer";

function App() {
  return (
    <div className="App overflow-x-hidden">
      <div id="scrolltop"></div>
      <Header />
      <main>
        <AppRoutes />
      </main>
      <Footer />
    </div>
  );
}

export default App;
